import cloneDeep from 'lodash/cloneDeep';

export function produce<T>(obj: T, mutator: (arg0: T) => void): T {
  const copy = cloneDeep(obj);
  mutator(copy);
  return copy;
}
